<template>
  <div class="content has_breadcrumb">
    <base-breadcrumb
      :data="[
        {
          routeName: 'announcementGroup',
          name: 'Group announcements'
        },
        {
          routeName: 'announcementGroup',
          name: statusDisplay,
          query: {
            status: activeIndex
          }
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage topType="location" pageType="6" title="Group announcements">
      <div slot="topAppBar"><search></search></div>
      <template v-slot:left>
        <div class="mar-l-b" v-if="activeIndex != 'Create'">
          <gg-create-button @click="openDialogAdd(null)" label="Create announcement" />
        </div>
        <gg-flex-menus :menus="menuDatas" @select="onMenuSelect" :default-active="activeIndex" />
      </template>

      <div class="collapse-list" v-infinite-scroll="loadAnnouncement">
        <p class="title">{{ title }}</p>
        <div class="announcement-inner">
          <div class="section-inner" v-loading="loading">
            <div
              class="section-box"
              :class="item.select === true ? 'select' : ''"
              v-for="(item, index) in announcementlist"
              :key="index"
            >
              <div
                class="section-head"
                @click="boxSelectFun(index)"
                @dblclick="todetail(item, index)"
              >
                <div class="section-head-l">
                  <a
                    class="section-title"
                    :href="todetailHref(item, index)"
                    @click.stop="onTitleClick($event, item, index)"
                  >
                    {{ htmlDecode(item.title) || '-' }}
                  </a>
                  <div class="section-des">
                    <div class="avatar" v-if="item.publishUserPhoto">
                      <img :src="item.publishUserPhoto" />
                    </div>
                    <div class="no" v-else>
                      {{
                        item.publishUserFirstName
                          ? item.publishUserFirstName.substring(0, 1).toUpperCase()
                          : '-'
                      }}{{
                        item.publishUserLastName
                          ? item.publishUserLastName.substring(0, 1).toUpperCase()
                          : '-'
                      }}
                    </div>
                    <div class="name">
                      {{ item.publishUserFirstName || '' + ' ' + item.publishUserLastName || '' }}
                    </div>
                    <div class="tag">{{ item.roleName }}</div>
                    <div class="date">
                      {{ item.status === 'draft' ? 'saved on ' : 'posted on '
                      }}{{ momentTime(item.modifyTime) }}
                    </div>
                  </div>
                </div>

                <div class="section-head-r">
                  <ul class="section-item">
                    <li>
                      <div class="val">{{ item.sumStudents }}</div>
                      <div class="tit">Students</div>
                    </li>
                    <li>
                      <div class="val">{{ item.sumClass }}</div>
                      <div class="tit">Classes</div>
                    </li>
                    <li>
                      <div class="val">{{ item.sumSchools || '-' }}</div>
                      <div class="tit">Location</div>
                    </li>
                    <li>
                      <div class="options" v-if="item.questionContent.options.length > 1">
                        <div class="val">
                          {{
                            !item.respondedRate || item.respondedRate === '0%'
                              ? '-'
                              : item.respondedRate
                          }}
                        </div>
                        <div class="tit">Responded</div>
                      </div>
                      <div class="options" v-else>
                        <div class="val">
                          {{ !item.viewedRate || item.viewedRate === '0%' ? '-' : item.viewedRate }}
                        </div>
                        <div class="tit">Viewed</div>
                      </div>
                    </li>
                  </ul>

                  <div class="section-col" v-if="getIfShowAction(item)">
                    <gg-menu-bar>
                      <i class="iconmore_vert-24px iconfont" />

                      <template slot="menus">
                        <gg-menu-bar-item
                          v-for="(menuitem, key) in actions"
                          @click="menuClick(menuitem, item, index)"
                          :disabled="menuitem === 'Post' ? postDisabled(item) : false"
                          :key="key"
                        >
                          <span>{{
                            typeof menuitem === 'object' ? menuitem.label : menuitem
                          }}</span>
                          <hr v-if="menuitem === 'Post'" class="hr" />
                        </gg-menu-bar-item>
                      </template>
                    </gg-menu-bar>
                  </div>
                  <div class="section-col" v-else></div>
                </div>
              </div>
              <div class="section-body" v-if="item.select === true">
                <div class="section-mail" v-html="formatHtml(item.body)"></div>
                <div class="section-file">
                  <div class="file-list-inner">
                    <div
                      class="file-box"
                      @click="viewfile(fileitem)"
                      v-for="(fileitem, fileindex) in item.addFile"
                      :key="fileindex"
                    >
                      <div class="file-head">
                        <pdf
                          style="width: 103px; height: 72px; text-align: center"
                          class="pdf-preview"
                          v-if="returnFileFormat(fileitem.url) === 'pdf'"
                          :id="fileitem.id"
                          :page="1"
                          :src="fileitem.url"
                        />
                        <el-image
                          v-else
                          style="width: 103px; height: 72px"
                          :src="fileitem.url"
                          fit="cover"
                        >
                        </el-image>
                      </div>
                      <div class="file-body">
                        <div class="file-name">File name: {{ fileitem.name || '-' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="announcementlist.length === 0 && !loading"
              slot="empty"
              style="text-align: center"
            >
              <div
                style="
                  display: inline-block;
                  width: 213px;
                  text-align: center;
                  border-radius: 50%;
                  margin-top: 210px;
                  margin-bottom: 22px;
                  line-height: 200px;
                "
              >
                <img
                  style="width: 100%"
                  :src="require('@/assets/images/moments/empty_photo.png')"
                />
              </div>
              <p style="font-size: 22px; color: #5f6368; font-family: 'Roboto'">
                No announcement yet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </GgPage>
    <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />

    <gg-Dialog
      width="580px"
      v-if="isDialogShow"
      :visible.sync="isDialogShow"
      title="Post announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">
        You have selected {{ activeItem.sumSchools }} location{{
          activeItem.sumSchools > 1 ? 's' : ''
        }}, {{ activeItem.sumClass }} class{{ activeItem.sumClass > 1 ? 'es' : '' }}, and
        {{ activeItem.sumStudents }} student{{ activeItem.sumStudents > 1 ? 's' : '' }}. Once the
        announcement is posted, it will be visible to all parents of the selected classes.
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDialogShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="updateAnnouncementStatus('post')">Post</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      :visible.sync="isDelectShow"
      title="Delete announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">Once deleted, you will not be able to recover the data.</div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDelectShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="removeAnnouncement('Draft')">Delete</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      v-if="isRecallShow"
      :visible.sync="isRecallShow"
      title="Recall announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">
        You are recalling this announcement from
        {{ activeItem.sumSchools }} location{{ activeItem.sumSchools > 1 ? 's' : '' }},
        {{ activeItem.sumClass }} class{{ activeItem.sumClass > 1 ? 'es' : '' }}, and
        {{ activeItem.sumStudents }} student{{ activeItem.sumStudents > 1 ? 's' : '' }}. Once
        recalled, it will no longer be visible to parents of the selected classes and will be moved
        to draft.
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isRecallShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="updateAnnouncementStatus('draft')">Recall</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      v-if="isArchiveShow"
      :visible.sync="isArchiveShow"
      title="Archive announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">
        You are archiving this announcement from
        {{ activeItem.sumSchools }} location{{ activeItem.sumSchools > 1 ? 's' : '' }},
        {{ activeItem.sumClass }} class{{ activeItem.sumClass > 1 ? 'es' : '' }}, and
        {{ activeItem.sumStudents }} student{{ activeItem.sumStudents > 1 ? 's' : '' }}. Once
        archived, it will be moved to Archived and parents will no longer be able to see it.
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isArchiveShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="updateAnnouncementStatus('archive')">Archive</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      :visible.sync="isRestoreShow"
      v-if="isRestoreShow"
      title="Restore announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">
        <!-- Once restored, the announcement will be shown in "Posted". -->
        You are restoring this announcement from
        {{ activeItem.sumSchools }} location{{ activeItem.sumSchools > 1 ? 's' : '' }},
        {{ activeItem.sumClass }} class{{ activeItem.sumClass > 1 ? 'es' : '' }}, and
        {{ activeItem.sumStudents }} student{{ activeItem.sumStudents > 1 ? 's' : '' }}. Once
        restored, it will be moved to posted and parents will be able to see it again.
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isRestoreShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="updateAnnouncementStatus('post')">Restore</gg-submit-button>
      </span>
    </gg-Dialog>

    <gg-Dialog
      width="580px"
      :visible.sync="isDelectShow"
      title="Delete announcement?"
      class="draft-dialog mp-dialog"
    >
      <div class="dialogContent">Once deleted, you will not be able to recover the data.</div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="isDelectShow = false">Cancel</gg-cancel-button>
        <gg-submit-button @click="removeAnnouncement('Archived')">Delete</gg-submit-button>
      </span>
    </gg-Dialog>

    <Snackbar :visible.sync="loadingShow" :content="loadingText" />
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import search from './modules/search'
import moment from 'moment'
import { Ajax } from '@/common'
import { routeHref, isPlainLeftClick } from '@/common/nav-state'
import { mapState } from 'vuex'
import { hasPermission } from './utils/utils.js'
export default {
  components: {
    pdf,
    search
  },
  data() {
    return {
      // title: "Draft announcements",
      saveobj: {},
      nowIndex: 0,
      pageHeight: 0,
      pages: 0,
      pageNum: 1,
      rootPath: process.env.VUE_APP_fileBasePath,
      loading: false,
      delId: '',
      isRestoreShow: false,
      isRecallShow: false,
      isArchiveShow: false,
      isDelectShow: false,
      isDialogShow: false,
      status: {
        DRAFT: 0,
        POSTED: 1,
        ARCHIVE: 2
      },
      loadingText: '',
      loadingShow: false,
      announcementlist: [],
      // actions: [],
      boxSelect: false,
      activeIndex: 'draft',
      menuDatas: [
        {
          name: 'Draft',
          key: 'draft',
          active: true
        },
        {
          name: 'Posted',
          key: 'post',
          active: true
        },
        {
          name: 'Archived',
          key: 'archive',
          active: true
        }
      ],
      snackbarData: {
        visible: false,
        content: ''
      },
      activeItem: null
    }
  },
  computed: {
    ...mapState({
      breadcrumb: (state) => state.breadcrumb,
      user: (state) => state.user
    }),
    title() {
      let activeItem = this.menuDatas.find((item) => item.key === this.activeIndex)
      return `${activeItem.name || '-'} Announcement`
    },
    statusDisplay() {
      return (
        this.menuDatas.find((item) => item.key === this.activeIndex) || {
          name: '-'
        }
      ).name
    },
    actions() {
      let actions = []
      if (hasPermission('Group Announcements_Full')) {
        if (this.activeIndex === 'draft') {
          actions = ['Post', 'Edit', 'Delete']
        } else if (this.activeIndex === 'post') {
          actions = ['Recall', 'Archive']
        } else if (this.activeIndex === 'archive') {
          actions = ['Restore', 'Delete']
        }
      }
      return actions
    }
  },

  created() {
    this.activeIndex = this.$route.query.status || 'draft'
    this.getAnnouncement()
  },
  mounted() {
    this.pageHeight = document.body.clientHeight - 64 - 57
  },
  methods: {
    hasPermission,

    questionOptionsSw(item) {
      let optionsSw = true,
        optionsInstructionSw = true

      for (let i = 0; i < item.questionContent.options.length; i++) {
        if (item.questionContent.options[i].label.length > 100) {
          optionsSw = false
          break
        }
      }
      if (item.questionContent.instruction.length > 255) {
        optionsInstructionSw = false
      }
      return optionsSw && optionsInstructionSw
    },
    getIfShowAction(item) {
      let show = this.actions.length > 0
      if (this.activeIndex === 'post') {
        show = show && !!item.groupAnnouncementId
      }
      return show
    },
    postDisabled(item) {
      console.log(
        'postDisabled',
        !item.title,
        item.title && item.title.length > 255,
        !item.body,
        !item.schoolClassJson,
        !this.questionOptionsSw(item),
        item.questionContent.options.length < 2,
        this.zzStr(item.body).length > 5000
      )
      //
      let disabled =
        !item.title ||
        (item.title && item.title.length > 255) ||
        !item.body ||
        JSON.parse(item.schoolClassJson).length === 0 ||
        !this.questionOptionsSw(item) ||
        this.zzStr(item.body).length > 5000
      disabled =
        disabled ||
        (item.questionContent.instruction ||
        item.questionContent.dueDate ||
        item.questionContent.options.length > 0
          ? item.questionContent.options.length < 2
          : false)
      return disabled
    },
    formatHtml(html) {
      return html.replace(/<p[^>]*>\s*<\/p>/g, '<p><br></p>')
    },
    htmlDecode(text) {
      var temp = document.createElement('div')
      temp.innerHTML = text
      var output = temp.innerText || temp.textContent
      temp = null
      return output
    },

    // zzStr(str) {
    //   return str.replace(/(<([^>]+)>)/ig,"").replace(/[\r\n]/g,"")
    // },

    zzStr(str) {
      str = str.replace(/<\/?[^>]*>/g, '')
      str = str.replace(/[ | ]*\n/g, '\n')
      return str
    },

    returnFileFormat(url) {
      let reg = /\.([0-9a-z]+)(?:[\?#]|$)/i
      return url.match(reg)[1]
    },

    viewfile(file) {
      const needPrint = 1
      let reg = /\.([0-9a-z]+)(?:[\?#]|$)/i
      let fileFormat = file.name.match(reg)[1]

      if (fileFormat === 'pdf') {
        let routeData = this.$router.resolve({
          path: '/testFileView',
          query: { url: file.url, name: file.name, needPrint: needPrint }
        })
        window.open(routeData.href, '_blank')
      } else {
        let routeData = this.$router.resolve({
          path: '/testFileView',
          query: { imgUrl: file.url, name: file.name, needPrint: needPrint }
        })
        window.open(routeData.href, '_blank')
      }
    },

    removeAnnouncement(type) {
      let data = {}
      data.id = this.delId
      this.isDelectShow = false

      Ajax.post('/announcement/group-announcements/remove/' + this.delId, data)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingText = `${type} has been deleted`
            this.loadingShow = true
            this.announcementlist.splice(this.nowIndex, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    updateAnnouncementStatus(status) {
      this.loading = true
      let data = {}
      data.id = this.delId
      data.status = status
      data.publishUser = this.user.userId
      this.isRecallShow = false
      this.isArchiveShow = false
      this.isRestoreShow = false
      this.isDialogShow = false
      Ajax.post('/announcement/group-announcements/updateStatusByIdV1', data)
        .then((res) => {
          if (res.code === '0000') {
            if (status === 'archive') {
              status = 'archiv'
            }
            if (status === 'draft') {
              status = 'recall'
            }
            this.loadingText = 'Announcement has been ' + status + 'ed'
            this.loadingShow = true
            this.announcementlist.splice(this.nowIndex, 1)
            this.loading = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    momentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    },

    loadAnnouncement() {
      if (this.pageNum < this.pages && !this.loading) {
        this.getAnnouncement(true)
      }
    },

    getAnnouncement(s) {
      this.loading = true
      this.pageNum = s ? this.pageNum + 1 : this.pageNum

      let data = {
        // schoolId: this.user.locationId,
        status: this.activeIndex,
        pageNum: this.pageNum,
        pageSize: 25,
        userId: this.user.userId
      }
      let postUrl =
        this.activeIndex === 'post'
          ? '/announcement/announcements/pageGroupByDraftV1'
          : '/announcement/group-announcements/pageByDraft'
      Ajax.get(postUrl, data).then((res) => {
        if (res.code === '0000') {
          let v = [],
            filearr = []
          for (let item of res.data.records) {
            let temp = item
            temp.select = false
            temp.questionContent = JSON.parse(item.questionContent)
            temp.body = this.htmlDecode(item.body)

            filearr = []
            if (item.addFile) {
              let filelist = item.addFile.split(',')
              for (var i = 0; i < filelist.length; i++) {
                filearr.push({
                  url: filelist[i],
                  name: item.fileDisplayName
                    ? item.fileDisplayName.split(',')[i]
                    : filelist[i].replace(
                        'https://classnovo-hk.oss-cn-hongkong.aliyuncs.com/dev/photo/',
                        ''
                      )
                })
              }
            }
            temp.addFile = filearr
            v.push(temp)
          }
          this.announcementlist.push(...v)
          this.loading = false
          this.pages = res.data.pages
        }
      })
    },

    // 单一来源：todetail(push) 与 todetailHref(中键/复制链接) 共用同一 location
    _todetailRoute(item) {
      let id = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
      if (this.activeIndex === 'post' && !item.groupAnnouncementId) {
        // 详情跳转只带路由 :id（详情页按 id 取数），不再把整包行对象塞进 sessionStorage
        return {
          name: 'announcementOtherDetail_post',
          params: { id: id }
        }
      }
      return {
        name: `announcementGroupDetail_${this.activeIndex}`,
        params: { id: id }
      }
    },
    todetail(item, index) {
      this.$router.push(this._todetailRoute(item))
    },
    // 防御式：走 routeHref，resolve 缺失/返回 undefined 都安全
    // @click.stop 无条件阻断冒泡到父级 boxSelectFun（保持多选不被重置）；
    // 仅纯左键 preventDefault + 走 SPA，修饰键/中键交给原生 <a href> 新开 tab
    onTitleClick(e, item, index) {
      if (!isPlainLeftClick(e)) return
      e.preventDefault()
      this.todetail(item, index)
    },
    todetailHref(item, index) {
      return routeHref(this.$router, this._todetailRoute(item))
    },

    menuClick(e, item, index) {
      this.activeItem = item
      if (e === 'Post') {
        this.delId = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
        this.nowIndex = index
        this.isDialogShow = true
        this.saveobj = {
          title: item.title,
          classid: item.classIds
        }
      }
      if (e === 'Delete') {
        this.delId = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
        this.nowIndex = index
        this.isDelectShow = true
      }
      if (e === 'Edit') {
        this.$router.push({
          name: 'createAnnouncementGroup',
          query: {
            editid: item.groupAnnouncementId ? item.groupAnnouncementId : item.id
          }
        })
      }
      if (e === 'Recall') {
        this.delId = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
        this.nowIndex = index
        this.isRecallShow = true
      }
      if (e === 'Archive') {
        this.delId = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
        this.nowIndex = index
        this.isArchiveShow = true
      }
      if (e === 'Restore') {
        console.log('menuClick', e)
        this.delId = item.groupAnnouncementId ? item.groupAnnouncementId : item.id
        this.nowIndex = index
        this.isRestoreShow = true
      }
    },

    boxSelectFun(index) {
      // if(event.path[0].className != 'iconmore_vert-24px iconfont' && event.path[1].className != 'drop_down_menus') {
      let v = this.announcementlist[index].select
      for (let i = 0; i < this.announcementlist.length; i++) {
        // this.announcementlist[i].select = false
        this.$set(this.announcementlist[i], 'select', false)
      }
      // this.announcementlist[index].select = !v
      this.$set(this.announcementlist[index], 'select', !v)
      // }
    },

    openDialogAdd() {
      this.$router.push({ name: 'createAnnouncementGroup' })
    },

    onMenuSelect(key, item) {
      this.activeIndex = key
      this.$router.replace({ query: { status: key } })
      this.pageNum = 1
      this.announcementlist = []
      this.getAnnouncement()
    }
  }
}
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.content {
  height: 100%;
  overflow-y: hidden;
}
.collapse-list {
  overflow: auto;
  .title {
    padding-left: 8px;
    padding-bottom: 26px;
    border-bottom: 1px solid #e3e3e3;
    color: #202124;
    font-size: 22px;
    font-weight: 600;
    font-family: OpenSans-Bold;
  }
}

.section-inner {
  .section-box {
    position: relative;
    background: #fff;
    box-sizing: border-box;
    color: #202124;
    border-radius: 13px;
    transition: ease 0.4s;
    min-width: 1000px;

    &.select {
      margin: 20px 0 5px 0;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

      .section-head {
        border-radius: 13px 13px 0 0;
        background-color: #e7effd;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

        .date,
        .section-item .tit {
          color: #5f6368 !important;
        }
      }

      .section-body {
        padding: 20px;
        max-height: 420px;
      }

      &:hover {
        .section-head {
          border-radius: 13px 13px 0 0;
        }
      }
    }

    &:hover {
      z-index: 1;
      border-radius: 13px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

      .section-head {
        border-radius: 13px;
      }
    }

    .section-head {
      position: relative;
      padding: 20px;
      height: 100px;
      background-color: #fff;
      border-bottom: 1px solid #e0e0e0;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .section-head-l {
        flex: none;
        padding-right: 24px;
        .section-title {
          display: inline-block;
          margin-bottom: 5px;
          font-size: 20px;
          font-family: OpenSans;
          // font-weight: 600;
          line-height: 27px;
          color: #202124;
          cursor: pointer;
          max-width: 750px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            color: #1a73e8;
          }
        }

        .section-des {
          .no {
            display: inline-block;
            margin-right: 8px;
            width: 24px;
            height: 24px;
            background: #b4b4b4;
            border-radius: 50%;
            line-height: 24px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            font-family: Open Sans;
            font-weight: 600;
          }

          .avatar {
            margin-right: 8px;
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: middle;

            img {
              display: block;
              width: 24px;
              height: 24px;
              border-radius: 50%;
            }
          }

          .name {
            margin-right: 8px;
            display: inline-block;
            font-size: 12px;
            font-family: Roboto;
            font-weight: 400;
            line-height: 19px;
            color: #202124;
            vertical-align: middle;
          }

          .tag {
            margin-right: 8px;
            display: inline-block;
            padding: 4px 9px;
            font-family: Roboto;
            height: 20px;
            line-height: 12px;
            background: #e0e0e0;
            border-radius: 10px;
            font-size: 12px;
            vertical-align: middle;
          }

          .date {
            margin-right: 8px;
            display: inline-block;
            font-size: 12px;
            font-family: Roboto;
            font-weight: 400;
            line-height: 16px;
            color: #b4b4b4;
          }
        }
      }

      .section-head-r {
        flex: none;

        .section-item {
          float: left;

          li {
            float: left;
            margin-right: 80px;

            .options {
              width: 90px;
            }

            .val {
              margin-bottom: 3px;
              font-size: 22px;
              font-family: OpenSans;
              // font-weight: 600;
              line-height: 30px;
              color: #202124;
            }

            .tit {
              font-size: 14px;
              font-family: Roboto;
              font-weight: 400;
              line-height: 19px;
              color: #b4b4b4;
            }
          }
        }

        .section-col {
          float: left;
          width: 40px;
          .menu_bar {
            margin-top: 12px;
            width: 40px;
            height: 40px;
            line-height: inherit;

            .drop_down_menus {
              padding: 0;
            }
          }

          .menu_bar .menu_bar_button:hover {
            background: none;
          }
        }
      }
    }

    .section-body {
      // max-height: 0;
      overflow-y: auto;

      .section-mail {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 500;
        line-height: 19px;
        color: #202124;
        word-break: break-all;
        /deep/ol,
        /deep/ul {
          margin-left: 1.2em;
        }
      }

      .file-list-inner {
        .file-box {
          margin-top: 20px;
          position: relative;
          height: 72px;
          line-height: 72px;
          background: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          overflow: hidden;
          cursor: pointer;

          .file-head {
            float: left;
            width: 103px;
            height: 72px;

            img {
              display: block;
              width: 103px;
              height: 72px;
            }
          }

          .file-body {
            padding: 0 20px;
            font-size: 12px;
            color: #202124;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
